import { FC } from 'react';
import { Paragraph, Row, Col, InlineLoader } from 'components';
import { ICurrency, IInvoice } from 'types';
import { parseIntoCurrencyString } from 'utils';
import { ConvertInfoWrapper } from './DecideConvertInfo.styles';
import { getInvoiceRemainingAmount } from 'utils/invoices';
import { UseCurrencyRateReturnValues } from 'hooks/useCurrencyRate';

interface OwnProps {
  currency: ICurrency | null;
  invoice: IInvoice;
  rate: UseCurrencyRateReturnValues['rate'];
}

const DecideConvertInfo: FC<OwnProps> = ({ currency, invoice, rate }) => {
  return (
    <ConvertInfoWrapper>
      <Col>
        <Paragraph>Amount Due</Paragraph>

        <Row>
          <svg>
            <use xlinkHref={`#${currency?.countryCode}`} />
          </svg>
          <Paragraph variant="bold">{`${
            currency?.symbol
          }${parseIntoCurrencyString(
            getInvoiceRemainingAmount(invoice),
            currency?.precision
          )}`}</Paragraph>
        </Row>
      </Col>
      <Col>
        <Paragraph>Current</Paragraph>

        <Row>
          <svg>
            <use xlinkHref={`#gb`} />
          </svg>
          <Paragraph variant="bold">
            {rate ? (
              `£${parseIntoCurrencyString(
                getInvoiceRemainingAmount(invoice) / rate
              )}`
            ) : (
              <InlineLoader />
            )}
          </Paragraph>
        </Row>
      </Col>
    </ConvertInfoWrapper>
  );
};

export default DecideConvertInfo;
